var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkModeMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6534 16.738C19.8623 16.4013 19.5771 15.9905 19.181 15.9983C19.1208 15.9995 19.0605 16.0001 19 16.0001C14.0294 16.0001 10 11.9707 10 7.00011C10 5.91499 10.192 4.87473 10.544 3.91145C10.6799 3.53934 10.3843 3.13583 9.998 3.22358C5.99102 4.13378 3 7.71765 3 12.0001C3 16.9707 7.02944 21.0001 12 21.0001C15.2321 21.0001 18.0663 19.2964 19.6534 16.738Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeMoon);
export default __webpack_public_path__ + "static/media/dark-mode-moon.d3410dcb9348ed4eb6c11e28647436f2.svg";
export { ForwardRef as ReactComponent };